
(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, require("../addon/attributes/index")) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports","../addon/attributes/index"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.PreviewSlide = this.HyperMD.PreviewSlide || {}), HyperMD.AttributesAddon);
})(function (require, exports, index_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.parseSlides = void 0;
    function parseSlides(html, slideConfigs) {
        var slides = html.split("<p>[MUMESLIDE]</p>");
        var before = slides[0];
        slides = slides.slice(1);
        var output = "";
        var i = 0;
        var h = -1; // horizontal
        var v = 0; // vertical
        while (i < slides.length) {
            var slide = slides[i];
            var slideConfig = slideConfigs[i];
            // resolve paths in slideConfig
            if ("data-background-image" in slideConfig) {
                slideConfig["data-background-image"] =
                    slideConfig["data-background-image"];
            }
            if ("data-background-video" in slideConfig) {
                slideConfig["data-background-video"] =
                    slideConfig["data-background-video"];
            }
            if ("data-background-iframe" in slideConfig) {
                slideConfig["data-background-iframe"] =
                    slideConfig["data-background-iframe"];
            }
            var attrString = index_1.stringifyAttributes(slideConfig, false); // parseAttrString(slideConfig)
            var classString = slideConfig["class"] || "";
            var idString = slideConfig["id"] ? "id=\"" + slideConfig["id"] + "\"" : "";
            if (!slideConfig["vertical"]) {
                h += 1;
                if (i > 0 && slideConfigs[i - 1]["vertical"]) {
                    // end of vertical slides
                    output += "</section>";
                    v = 0;
                }
                if (i < slides.length - 1 && slideConfigs[i + 1]["vertical"]) {
                    // start of vertical slides
                    output += "<section>";
                }
            }
            else {
                // vertical slide
                v += 1;
            }
            output += "<section " + attrString + " " + idString + "  class=\"slide " + classString + "\" data-line=\"" + slideConfig["lineNo"] + "\" data-h=\"" + h + "\" data-v=\"" + v + "\">" + slide + "</section>";
            i += 1;
        }
        if (i > 0 && slideConfigs[i - 1]["vertical"]) {
            // end of vertical slides
            output += "</section>";
        }
        /*
        // check list item attribtues
        // issue: https://github.com/shd101wyy/markdown-preview-enhanced/issues/559
        const $ = cheerio.load(output);
        $("li").each((j, elem) => {
          const $elem = $(elem);
          const html2 = $elem.html().trim();
          const attributeMatch = html2.match(/<!--(.+?)-->/);
          if (attributeMatch) {
            const attributes = attributeMatch[1].replace(/\.element\:/, "").trim();
            const attrObj = parseAttributes(attributes);
            for (const key in attrObj) {
              if (attrObj.hasOwnProperty(key)) {
                $elem.attr(key, attrObj[key]);
              }
            }
          }
        });
        */
        return "\n  <div style=\"display:none;\">" + before + "</div>\n  <div class=\"reveal\">\n    <div class=\"slides\">\n      " + output + "\n    </div>\n  </div>\n  ";
    }
    exports.parseSlides = parseSlides;
});
